import Dexie, { type EntityTable } from 'dexie';
import { Log } from '../types';

export abstract class BaseDB extends Dexie {
  logs!: EntityTable<Log, 'id'>;

  constructor(
    name: string,
    version: number,
    additionalSchemas: Record<string, string> = {},
  ) {
    super(name);

    const commonSchema = {
      logs: 'id, level, time, source, account',
    };

    this.version(version).stores({ ...commonSchema, ...additionalSchemas });
  }
}
